module.exports = __webpack_public_path__ + "static/media/haiwai11.a148ca47.png";